/**
 * Application Configuration Constants
 * รวมการตั้งค่าหลักของแอพไว้ที่เดียว
 */

// SEO Title สำหรับ NurseApp - ใช้ในทุกหน้าเพื่อ SEO
export const NURSE_APP_TITLE = 'NurseApp แอพสำหรับพยาบาล - จัดการเวรและอุปกรณ์ได้ง่ายในที่เดียว - ระบบตรวจสอบอุปกรณ์อัตโนมัติ ลดเวลาและความผิดพลาด - แลกเวรได้ง่าย อนุมัติได้เร็ว';

// App Name
export const APP_NAME = 'NurseApp';

// App Description
export const APP_DESCRIPTION = 'แอพสำหรับพยาบาล จัดการเวรและอุปกรณ์ได้ง่ายในที่เดียว';

// App Keywords สำหรับ SEO
export const APP_KEYWORDS = 'NurseApp, ระบบจัดการพยาบาล, ระบบจัดการผู้ช่วยพยาบาล, จัดการเวร, จัดการอุปกรณ์, พยาบาล, แอพพยาบาล, nurse management, shift management, equipment management';

